const ITEMS = [
  "3,117 ADA LAWSUITS FILED IN 2025",
  "UP 27% FROM 2024",
  "64% TARGETED COMPANIES UNDER $25M",
  "94.8% OF WEBSITES FAIL BASIC CHECKS",
  "1 IN 4 U.S. ADULTS LIVE WITH A DISABILITY",
  "7,000+ LAWSUITS EXPECTED IN 2026",
  "APRIL 2027 — ADA TITLE II DEADLINE",
];

const Track = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center whitespace-nowrap">
        <span
          className={`font-display text-xl sm:text-2xl tracking-wide ${i % 2 === 0 ? "text-white" : "text-brandamber"}`}
        >
          {item}
        </span>
        <span className="mx-6 font-mono text-sm text-alert">///</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative border-y border-white/10 bg-panel py-4 overflow-hidden marquee-hover">
    <div className="hazard-line" />
    <div className="marquee-mask flex overflow-hidden">
      <div className="marquee-track flex">
        <Track />
        <Track ariaHidden />
      </div>
    </div>
    <div className="hazard-line" />
  </div>
);
